var schemaOrgTemplate = require('templates/schemaOrg.hbs');
var AriesComponent = require('libs/aries-component');

AriesComponent.create({
  type: 'schemaOrg',

  template: {
    'schemaOrg': schemaOrgTemplate
  },
  bindEvents: function() {}
});
